module.exports = __webpack_public_path__ + "static/media/no-wifi.c8496965.svg";